import {httpFetch} from './httpTransport';
import {ECOMMERCE_API_BASE_URL} from '../config';
import {readQuery} from './queryCache';
import {apiErrorMessage,readErrorBody} from './errorMessage';
let initial:{url:string;response:Promise<Response>;controller:AbortController}|undefined;
/** Start the public body read while the document UI chunk downloads. No persistent cache. */
export function prefetchDocument(){
 try{
  const value=JSON.parse(document.getElementById('withpot-document')?.textContent??'null');
  if(!value||'/'+value.code!==window.location.pathname)return;
  const {kind,token,options}=value.data;
  if(!['handbook','picking','invite'].includes(kind)||!(/^\w{64}$/.test(token)||(kind==='invite'&&/^live-(?:session|purge)-[1-9][0-9]{0,9}$/.test(token))))return;
  const query=new URLSearchParams();
  if(kind==='invite'&&options.order){const {itemIds,...order}=options.order;query.set('order',JSON.stringify(order));}
  if(kind==='picking'){
   query.set('view',options.view);
   if(options.order){const {itemIds,...order}=options.order;query.set('order',JSON.stringify(order));}
  }
  const url=`${ECOMMERCE_API_BASE_URL}/erp/${kind}/${token}${query.size?'?'+query.toString():''}`;
  initial?.controller.abort();
  const controller=new AbortController();
  const response=httpFetch(url,{signal:controller.signal});void response.catch(()=>{});initial={url,response,controller};
 }catch{/* Normal document loading reports invalid bootstrap or request failures. */}
}
export function documentFetch(url:string,init:RequestInit={}){
 if(init.signal?.aborted)return Promise.reject(new DOMException('Request cancelled','AbortError'));
 const canonical=(value:string)=>{const parsed=new URL(value,window.location.origin);parsed.searchParams.sort();return parsed.toString();};
 if((!init.method||init.method==='GET')&&initial&&canonical(url)===canonical(initial.url)){
  const pending=initial;initial=undefined;
  const cancel=()=>pending.controller.abort();
  init.signal?.addEventListener('abort',cancel,{once:true});
  // Keep cancellation through body consumption, not just response headers.
  // readQuery releases its signal when the JSON read finishes.
  return pending.response;
 }
 return httpFetch(url,init);
}

/** Public documents need the same full-body deadline/cancellation as ERP reads.
 * Always fresh: checks and shortages must never reuse an old document snapshot.
 * Mutations remain on documentFetch and are never retried here.
 */
export function documentJson<T>(url:string,init:RequestInit={}):Promise<T>{
 return readQuery(`document|${url}`,async signal=>{
  const response=await documentFetch(url,{...init,signal});
  if(!response.ok)throw new Error(apiErrorMessage(response.status,await readErrorBody(response)));
  return response.json();
 },{signal:init.signal??undefined,staleTime:0});
}
